export default __webpack_public_path__ + "static/media/truck-visits.391b3252.svg";